<template>
	<div class="innerBox">
		<div class="row">
			<div class="col-12 col-md-9 mt-1">
				<h3 class="mb-4">Pembelian Stock Sparepart</h3>
			</div>
			<div class="col-12 col-md-3 mt-1">
				<button
					class="btn btn-outline-success w-100"
					type="button"
					@click="updateStock"
				>
					<i class="fas fa-file-excel"></i> Unggah Excel Stok Barang
				</button>
			</div>
		</div>
		

		<div class="row rounded border border-secondary p-10 mt-2" style="color:white;background-color:#222;min-height:500px">
			<div class="col-12">
				<div class="row mt-4 text-center">
					<div class="col-4 middleDiv">
						<h5>Penerima Barang</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<Multiselect
							:options="labourerList.map(x => x.id)"
							:custom-label="opt => labourerList.find(x => x.id == opt).name"
							v-model="form.labourer_id"
							v-if="labourerList"
							class="w-100"
							placeholder="Pilih Pekerja"
						/>
					</div>
				</div>

				<div class="row mt-4 text-center">
					<div class="col-4 middleDiv">
						<h5>Pilih Supplier</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<Multiselect
							:options="supplierList.map(x => x.id)"
							:custom-label="opt => supplierList.find(x => x.id == opt).name"
							v-model="form.supplier_id"
							v-if="supplierList"
							placeholder="Pilih Supplier"
							class="w-100"
						/>
					</div>
				</div>

				<div class="row mt-4 text-center">
					<div class="col-4 middleDiv">
						<h5>Tanggal Pembelian</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<flat-pickr
							v-model="form.created_at"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>
					</div>
				</div>



				<table class="table bg-white mt-4 text-center">
					<thead>
						<th>No.</th>
						<th>Nama Sparepart</th>
						<th>Tipe Sparepart</th>
						<th>Jumlah</th>
						<th>Total Harga</th>
						<th><i class="fa fa-cog"></i></th>
					</thead>
					<tbody>
						<tr v-for="(detail, index) in form.listSparepart" :key="index">
							<td>{{index + 1}}</td>
							<td>{{detail.sparepart_name}}</td>
							<td>{{detail.sparepart_type}}</td>
							<td>{{numberWithCommas(detail.amount)}}</td>
							<td>Rp. {{numberWithCommas(detail.price)}}</td>
							<td>
								<button type="button" class="btn btn-danger" @click="deleteIndex(index)"><i class="fa fa-times"></i></button>
							</td>
						</tr>
						<tr>
							<td colspan="6">
								<h5 style="text-decoration:underline;color:#888" class="textHover" @click="addSparepartModal = true">Klik Disini Untuk Menambah Sparepart</h5>
							</td>
						</tr>
					</tbody>
				</table>


				<div class="row mt-4">
					
					<div class="offset-6 col-3">
						
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
					<div class="col-3" >
						<button class="btn btn-primary w-100" @click="submit">Selesai</button>
					</div>
				</div>
			</div>
		</div>
		<addSparepart
			v-if="addSparepartModal"
			@closeModal="addSparepartModal = false"
			@updateData="updateForm"
		/>

		<uploadFile 
			v-if="uploadExcel"
			@closeModal="uploadExcel = false"
			@file="afterUpload"
			:title="'Unggah Excel Stok Barang'"
			:template="'template_stock.xlsx'"
		/>

		<view-change-modal 
			:stockChange="stockChange"
			:labourerList="labourerList"
			:supplierList="supplierList"
			:apiLoading="apiLoading"
			v-if="stockChange"
			@closeModal="stockChange = null"
			@approved="executeUpdateStockBatch"
		/>
		

		
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import addSparepart from './childComponents/addSparepart'
import moment from 'moment'
import uploadFile from '@/components/modal/uploadFile'
import viewChangeModal from './childComponents/viewChangeModal.vue'
// import XLSX from 'xlsx'
const XLSX = require('xlsx')

export default {
	components : {
		Multiselect,
		addSparepart,
		uploadFile,
		viewChangeModal
	},
	data () {
		return {
			form : {
				labourer_id : null,
				supplier_id : null,
				listSparepart : [],
				created_at : new moment().format('Y-MM-DD')
			},
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL(),
				enableTime : true
			},
			addSparepartModal : false,
			uploadExcel : false,
			file : null,
			url : null,
			fileError : '',
			labourerList : null,
			supplierList : null,
			apiLoading : false,
			isLoading : false,
			stockChange : null
		}
	},
	watch : {
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
		}
	},
	mounted () {
		this.getListOfLabourer()
		this.getListOfSupplier()
	},
	methods : {
		executeUpdateStockBatch (supplier_id , labourer_id) {
			if(this.apiLoading) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon tunggu karena process sedang berlanjut'])
				return
			}

			this.apiLoading = true

			let dataSent = {
				data : this.stockChange,
				labourer_id : labourer_id,
				supplier_id : supplier_id
			}
			this.$http.post('/api/v1/inventory/batch' , dataSent)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Stok Bahan Telah Berhasil Di Update']);
				this.apiLoading = false
				this.stockChange = null
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Update Stok Gagal.' , err])
				console.log(err)
				this.apiLoading = false
			})

		},
		updateStock () {
			this.uploadExcel = true
		},
		afterUpload (file) {
			var reader = new FileReader();

			reader.onload = async (e) => {
				/* Parse data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, { type: 'binary' });
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
				const data = XLSX.utils.sheet_to_json(ws);

				// this.$http.post()

				try {
					// let response = await this.$http.post('/api/v1/inventory/batch' , data)
					let response = await this.$http.get('/api/v1/inventory?ignoreSize=true&k=Type.name&c==&v=B')
					let currentStock = response.data.data
					// console.log(currentStock)

					let stockChange = []
					for(var i = 0 ; i < data.length ; i++) {
						console.log(data[i])
						if(data[i]['jumlah_stok'] == 0 || !data[i]['jumlah_stok'])
							continue

						let curBahan = data[i]
						let searchSparepart = currentStock.find(x => x.sparepart_name == curBahan.name)

						searchSparepart.change_stock = parseFloat(curBahan.jumlah_stok) - parseFloat(searchSparepart.stocks ? searchSparepart.stocks : 0)
						searchSparepart.new_stock = parseFloat(curBahan.jumlah_stok)

						// console.log(searchSparepart.change_stock)

						stockChange.push(searchSparepart)
					}


					this.stockChange = stockChange
					// console.log(stockChange)
					// this.$store.dispatch('triggerAlert')
				}
				catch(err) {
					console.log(err)
					this.$store.dispatch('triggerAlert' , [false , 'Update Stock Failed.' , err])
				}

				// console.log(data)
			}

			reader.readAsBinaryString(file);

		},
		reset() {
			this.form.labourer_id = null
			this.form.supplier_id = null
			this.form.listSparepart.length = 0;
		},
		async validate (data) {
			let error = []

			if(!data.labourer_id) {
				error.push('Mohon Dipilih Pekerja Terlebih Dahulu!')
			}

			if(!data.supplier_id) {
				error.push('Mohon Dipilih Supplier Terlebih Dahulu!')
			}

			if(data.listSparepart.length <= 0) {
				error.push('Pembelian Sparepart Tidak Boleh Kosong!')
			}
			return error
		},
		async calculateTotalPrice(data) {
			let price = 0

			for(var i = 0; i < data.length ; i++) {
				price += data[i].price
			}

			return price
		},
		async submit () {
			if(this.isLoading) {
				this.$store.dispatch('triggerAlert' , [false , 'Process pembelian stock sedang berlangsung. mohon dicoba beberapa saat lagi.'])
				return
			}

			this.isLoading = true
			console.log(this.form)
			let error = await this.validate(this.form)

			if(error.length > 0) {
				this.$store.dispatch('triggerAlert' , [false , error])
				this.isLoading = false
				return
			}

			let totalPrice = await this.calculateTotalPrice(this.form.listSparepart)

			let obj = {
				amount : totalPrice,
				description : 'Purchase Record For Pembelian Stok Sparepart',
				debit_credit : -1,
				transaction_type_id : 5,
				created_at : this.form.created_at
			}

			let obj2 = {
				amount : totalPrice,
				description : 'Accounts Payable for Pembelian Stok Sparepart',
				debit_credit : 1,
				transaction_type_id : 9,
				created_at : this.form.created_at
			}
			// console.log(obj)

			this.$http.post('/api/v1/transactions' , obj)
			.then(async (resp) => {
				let transactionId = resp.data.data.id

				// Balance The Account Transaction
				let transaction2 = await this.$http.post('/api/v1/transactions' , obj2)


				for(var i = 0; i < this.form.listSparepart.length ; i++) {
					let sparepart = this.form.listSparepart[i]

					let dataInventory = {
						sparepart_id : sparepart.sparepart_id , 
						amount : sparepart.amount,
						transaction_id : transactionId,
						labourer_id : this.form.labourer_id,
						supplier_id : this.form.supplier_id,
						price_per_item : this.form.listSparepart[i].price / this.form.listSparepart[i].amount,
						is_paid : false,
						created_at : this.form.created_at
					}

					this.$http.post('/api/v1/inventory' , dataInventory)
					.then((resp) => {
						this.$store.dispatch('triggerAlert' , [true , 'Pembelian Stok Berhasil'])
						if(this.form.listSparepart.length > 1) {
							this.form.listSparepart.splice(i , 1)
						}
						else {
							this.reset()
						}
						this.isLoading = false
						
					})
					.catch((err) => {
						console.log(err)
						this.isLoading = false
					})

				}
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Ada Terjadi Masalah Dengan System Kami. Mohon Dicoba lagi beberapa saat lagi.'])
				console.log(err)
				this.isLoading = false
			})

			
		},
		updateForm(data) {
			this.addSparepartModal = false
			this.form.listSparepart.push(data)
		},
		deleteIndex(index) {
			this.form.splice(index , 1)
		},
		getListOfSupplier () {
			this.supplierList = null

			this.$http.get('/api/v1/masterData/supplier?pagination=false')
			.then((resp) => {
				this.supplierList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getListOfLabourer () {
			this.labourerList = null

			this.$http.get('/api/v1/masterData/labourer?pagination=false')
			.then((resp) => {
				this.labourerList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
	.textHover:hover {
		color : black !important;
	}
</style>